/*
 *
 * Basic Theme
 *
 */

import './scss/style.scss';
import './js/header.js';
import './js/accordion.js';
import "./js/carousel.js";
import './js/icons/svgxuse.min.js';
require.context('./images', true);